<template>
    <div class="col-12 col-md-6 col-xl-3">
            <h5 data-test="footerHead2" id="footerHead2-contact-address">{{$t(data.moduleHeading)}}</h5>
            <ul>
              <li data-test="footerHead3" id="footerHead3">
                {{$t(data.addressLine1)}}
                <br data-test="footerHead4" id="footerHead4" />{{$t(data.addressLine2)}}
                <br data-test="footerHead5" id="footerHead5" />{{$t(data.addressLine3)}}
                <br />
                <br data-test="footerHead6" id="footerHead6" />{{$t(data.addressLineEmail)}}
              </li>
            </ul>
          </div>
</template>
<script>
export default {
	props: {
		data: {
			type: Object
		}
	}
}
</script>
